import { ActionType, ProColumns } from "@ant-design/pro-components";
import { DatePicker, Form, Input, Popconfirm, Typography } from "antd";
import { ROUTES } from "base/routes/routes";
import BoxContainer from "base/ui/components/BoxContainer";
import CustomButton from "base/ui/components/Button";
import CustomSelect from "base/ui/components/CustomSelect";
import CustomProTable, {
  tablePagination,
} from "base/ui/components/CustomTable";
import { CheckStatus, CloseStatus, Plus } from "base/ui/components/Icons";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import { ButtonEdit } from "pages/Components/FunctionButton";
import PageWrapper from "pages/Components/PageWrapper";
import { SearchItem } from "pages/Components/SearchBox";
import { dropdownstatus } from "pages/Components/dataDropDown";
import { SearchModel } from "pages/model";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SurveyAPIModel } from "services/Survey/survey_services";
import { commonPresenter, commonStore, surveyPresenter, surveyStore } from "stores/root_store";
import { BASE_URL, PAGE_SIZE_DEFAULT, VARIABLE_CHECK_ZALO } from "utils/constants";
import { checkPermission, useCheckPermission } from "utils/permissionHelper";


import { CopyOutlined } from '@ant-design/icons';
import ButtonIcon from 'base/ui/components/Button/buttonIcon';
import dayjs from 'dayjs';
import { CommonModel } from 'services/Main/common_services';
import useDebounce from 'hooks/useDebounce';



const { Text } = Typography;

const { RangePicker } = DatePicker;

export function formSurvey() {
  return observer(() => {
    // Phân quyền
    useCheckPermission("INDEX");
    // ============ Navigation =================/
    const navigate = useNavigate();

    const [form] = Form.useForm();
    const tableRef = useRef<ActionType>();


    // Tìm kiếm / phân trang
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      name: undefined,
      actived: true,
    });
    // data table mẫu khảo sát
    const [dataTable, setDataTable] = useState<SurveyAPIModel[]>([]);
    const [loading, setLoading] = useState(false);


    const [commonSurvey, setCommonSurvey] = useState<CommonModel[]>([]);


    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);
    // =================================================================================================

    //CÁC HÀM LẤY DATA=================================================================

    const getDataTable = async (dataSearch: any) => {
      setLoading(true);
      await surveyPresenter.getListSurvey(surveyStore, dataSearch);
      setLoading(false);

      if (surveyStore.listSurveys.isSuccess) {
        const dataTemp = cloneDeep(surveyStore.listSurveys.data);
        setDataTable(dataTemp);

        return dataTemp;
      }
      setDataTable([]);
      return [];
    };


    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue("createTime", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("createTime", undefined);
      }
    };


    // DANH SÁCH COMMON MẪU KHẢO SÁT -------------------------------------------------------------------------
    const getListCommonSurvey = async (key?: string, createTimeFrom?: string, createTimeTo?: string) => {
      const listCommon = await surveyPresenter.getListCommonSurvey(key, createTimeFrom, createTimeTo);
      setCommonSurvey(listCommon);
    };

    const debounceCommonSurvey = useDebounce(getListCommonSurvey, 300)




    // =================================================================
    const handleOk = (id: string) => {
      navigate(`add?duplicate=${id}`);
    };

    const columns: ProColumns<SurveyAPIModel>[] = [
      {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        align: "center",
        width: 50,
      },
      // Id mẫu khảo sát
      {
        title: "ID mẫu khảo sát",
        dataIndex: "code",
        key: "code",
        align: "center",
        width: 100,
        render(dom, entity, index, action, schema) {
          return (
            <Link
              target="_blank"
              to={
                ROUTES.SURVEY_TABLE.FEEDBACK.LINK + entity.id
                // generateNameId({ id: entity.id, name: entity.name })
              }
            >
              {dom}
            </Link>
          );
        },
      },
      // Tên khảo sát
      {
        title: "Tên khảo sát",
        dataIndex: "aliasName",
        key: "aliasName",
        width: 350,
        render(dom, entity, index, action, schema) {
          return (
            <div className='flex gap-2'>
              {/* <Link
                target="_blank"
                to={
                  ROUTES.SURVEY_TABLE.FEEDBACK.LINK +
                  generateNameId({ id: entity.id, name: entity.name })
                }
              >
                {dom}
              </Link> */}
              <div>{dom}</div>
              <Text
                className='!text-base'
                copyable={{
                  text: `${BASE_URL}/Feedback/${entity.id}?TaskId=null&env=${VARIABLE_CHECK_ZALO}`,
                  tooltips: ['Copy URL', 'Copied'],
                }}
              />
            </div>
          );
        },
      },
      // thời gian tạo
      {
        title: "Thời gian tạo",
        dataIndex: "createTime",
        key: "createTime",
        align: "center",
        width: 150,
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm:ss",
        },
      },
      // người tạo
      {
        title: "Người tạo",
        dataIndex: "createBy",
        key: "createBy",
        width: 200,
      },
      // trạng thái
      {
        title: "Trạng thái",
        dataIndex: "actived",
        key: "actived",
        width: 100,
        render: (_, record) =>
          record.actived ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
      // Chức năng
      {
        title: "Chức năng",
        dataIndex: "action",
        key: "action",
        onCell: () => {
          return {
            style: {
              textAlign: "center",
            },
          };
        },
        render: (text, record) => {
          return (
            <div className='flex gap-2 items-center'>
              {checkPermission("EDIT") && (
                // <Link to={ROUTES.SURVEY_TABLE.EDIT.LINK + record.id}>
                <ButtonEdit onClick={() => navigate(ROUTES.SURVEY_TABLE.EDIT.LINK + record.id)} />
                // </Link>
              )}
              <Popconfirm
                title="Duplicate"
                description="Bạn có xác nhận nhân đôi mẫu khảo sát này"
                onConfirm={() => handleOk(record.id)}
              >
                <ButtonIcon
                  color="#389e0d"
                  className={`!leading-[25px] !h-[25px]`}
                >
                  <CopyOutlined className="!text-[#389e0d] flex" />
                </ButtonIcon>
              </Popconfirm>
              <Text
                className='!text-base'
                copyable={{
                  text: `${BASE_URL}/Feedback/${record.id}?TaskId=<task_id>&env=<env>`,
                  tooltips: ['Copy URL ZNS', 'Copied'],
                }}
              />
            </div >
          );
        },
        width: 100,
      },
    ];

    useEffect(() => {
      getListCommonDate();
    }, []);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: "Form khảo sát",
          },
        ]}
        extras={
          <>
            {checkPermission("CREATE") && (
              <Link to={"add"}>
                <CustomButton
                  type="primary"
                  icon={<Plus className="!fill-white" />}
                >
                  Thêm mới
                </CustomButton>
              </Link>
            )}
          </>
        }
      >
        <BoxContainer>
          <Form
            layout="horizontal"
            form={form}
            onFinish={(values) => {
              const ngayTao = values["createTime"];
              let fromTime = undefined;
              let toTime = undefined;
              if (ngayTao) {
                fromTime = ngayTao[0].format("YYYY-MM-DD") || undefined;
                toTime = ngayTao[1].format("YYYY-MM-DD") || undefined;
              }
              setDataPaging({
                ...values,
                fromTime: fromTime,
                toTime: toTime,
                paging: { ...dataPaging.paging, pageIndex: 1 },
              });
              tableRef.current?.reload();
            }}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ actived: true }}
          >
            <div className="w-full flex flex-col gap-2 md:grid md:grid-cols-2">
              <SearchItem name={"name"} label="Tên khảo sát">
                <CustomSelect
                  options={commonSurvey}
                  fieldNames={{ label: "value", value: "key" }}
                  filterOption={false}
                  onSearch={(value) => debounceCommonSurvey(value || undefined)}
                  onClear={() => debounceCommonSurvey()}
                  onClick={() => debounceCommonSurvey()}
                  showSearch
                  allowClear
                />
              </SearchItem>
              <SearchItem
                name={"actived"}
                label="Trạng thái"
              >
                <CustomSelect options={dropdownstatus} />
              </SearchItem>
              <SearchItem name={"commonDate"} label={"Ngày tạo"} start>
                <CustomSelect
                  options={listCommonDate}
                  fieldNames={{ label: "value", value: "key" }}
                  onChange={async (value, option) => {
                    if (option) {
                      setDisableRangePicker(
                        option.key === "Custom" ? false : true
                      );
                      await getDateByKey(option.key);
                    } else {
                      setDisableRangePicker(false);
                      form.setFieldValue("createTime", undefined);
                    }
                  }}
                  allowClear
                />
              </SearchItem>
              <SearchItem
                name={"code"}
                label="Id mẫu khảo sát"
              >
                <Input />
              </SearchItem>
              {/* chọn ngày*/}
              <SearchItem label={' '} colon={false} name={"createTime"}>
                <RangePicker
                  disabled={disableRangePicker}
                  format="DD/MM/YYYY"
                  className="w-full"
                />
              </SearchItem>


              <div className="w-full md:col-span-2">
                <CustomButton
                  loading={loading}
                  className="mx-auto"
                  htmlType="submit"
                  type="primary"
                >
                  Tìm kiếm
                </CustomButton>
              </div>
            </div>
          </Form>
        </BoxContainer>
        <BoxContainer>
          <CustomProTable<SurveyAPIModel>
            options={false}
            handleResize={() => { }}
            bordered
            dataSource={dataTable}
            columns={columns}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy:
                    Object.values(sort)[0] === "ascend"
                      ? `${Object.keys(sort)[0].split(",").pop()}`
                      : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === "descend"
                      ? `${Object.keys(sort)[0].split(",").pop()}`
                      : undefined,
                },
              });

              if (Object.values(sort).length) {
                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                  },
                });
              }
              return {
                data: data,
                success: surveyStore.listSurveys.isSuccess,
              };
            }}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: surveyStore.listSurveys.paging?.totalCount,
            }}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
}
